import React from "react";
import { Link } from "react-router-dom";
import routes from "../../seo/routes.json";
import "../MailchimpAlternative/MailchimpAlternative.css";
import "../SeoLandingPage/SeoLandingPage.css";
import "./FAQ.css";

const faqRoute = routes.find((route) => route.path === "/faq");
const faqs = faqRoute?.faqs || [];

const groups = [
  {
    eyebrow: "Email marketing basics",
    items: faqs.slice(0, 4),
  },
  {
    eyebrow: "Campaign workflow",
    items: faqs.slice(4, 8),
  },
  {
    eyebrow: "Accounts and support",
    items: faqs.slice(8),
  },
];

export default function FAQ() {
  return (
    <main className="mailchimp-page faq-page">
      <section className="mailchimp-hero faq-hero">
        <div className="mailchimp-hero-copy">
          <span className="mailchimp-eyebrow">Mailsnappy FAQ</span>
          <h1>Email Marketing FAQ</h1>
          <p>
            Find answers about Mailsnappy email marketing software, campaign creation, templates,
            automation, segmentation, analytics, pricing, and support.
          </p>
          <div className="mailchimp-actions">
            <Link to="/email-marketing-software">Explore email marketing software</Link>
            <Link className="secondary" to="/pricing">View pricing</Link>
          </div>
        </div>
        <div className="seo-landing-panel faq-panel" aria-label="Mailsnappy FAQ topics">
          <div className="seo-landing-window">
            <span />
            <span />
            <span />
          </div>
          <div className="faq-topic-list">
            <b>Email campaigns</b>
            <b>Automation</b>
            <b>Templates</b>
            <b>Segmentation</b>
            <b>Analytics</b>
          </div>
        </div>
      </section>

      <section className="faq-groups" aria-label="Frequently asked questions">
        {groups.map((group) => (
          <div className="faq-group" key={group.eyebrow}>
            <span>{group.eyebrow}</span>
            {group.items.map((item) => (
              <article className="faq-item" key={item.question}>
                <h2>{item.question}</h2>
                <p>{item.answer}</p>
              </article>
            ))}
          </div>
        ))}
      </section>

      <section className="mailchimp-better faq-related">
        <div>
          <span>Explore related Mailsnappy pages</span>
          <h2>Keep building your email marketing workflow</h2>
          <p>
            Use these pages to learn more about designing email templates, automating subscriber
            journeys, segmenting audiences, and reviewing campaign performance.
          </p>
          <div className="related-page-links" aria-label="Related email marketing pages">
            <Link to="/templates">responsive email templates</Link>
            <Link to="/automation">email automation features</Link>
            <Link to="/segmentation">audience segmentation</Link>
            <Link to="/analytics">campaign analytics</Link>
          </div>
        </div>
        <Link to="/email-marketing-platform">View platform overview</Link>
      </section>
    </main>
  );
}
